import React, { useCallback } from "react"
import { TextField, Grid, InputAdornment } from "@mui/material"
import { AppButtonIcon, AppModal } from "@components"
import { sftpCreatedPassword } from "Pages/Admin/ExportConnections/@signals"

export default function SftpPasswordModal() {
	const onClose = useCallback(() => { sftpCreatedPassword.value = null }, [])

	const onCopy = useCallback(() => {
		navigator.clipboard.writeText(sftpCreatedPassword.value)
	}, [])

	return <AppModal
		icon="key"
		title="SFTP User Created"
		subtitle="Password of the new user"
		containerProps={{ maxWidth: 'sm' }}
		isOpen={!!sftpCreatedPassword.value}
		controller={onClose}
		hideActions
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<TextField
					fullWidth
					label="Password"
					value={sftpCreatedPassword.value ?? ""}
					InputProps={{
						readOnly: true,
						endAdornment: <InputAdornment position="end">
							<AppButtonIcon icon="copy" tooltip="Copy" onClick={onCopy}/>
						</InputAdornment>,
					}}
				/>
			</Grid>
		</Grid>
	</AppModal>
}